import { queries } from "@testing-library/react";
import React, { useRef } from "react";
import { useState } from "react";
import { useEffect } from "react";
import SocialsContainer from "./ArticleSocialsContainer";
import WrongSocialsContainer from "./ArticleWrongSocialsContainer";


const IMG_HEIGHT = 150;

function getElementRealHeight(element, maxHeight, addPadding) {
  let height = 0;
  for (let i = 0; i < element.childElementCount; i++) {
    const el = element.childNodes[i];
    if (el.classList.contains("cup") && el.clientHeight === 0 && window.innerWidth < 700) {
      height += 150;
    }
    else height += el.clientHeight;
  }
  var quizHeadlineHeight = document.querySelector('.ArticleQuiz').offsetHeight;
  return Math.max(height, maxHeight ? maxHeight : quizHeadlineHeight + (addPadding ? 150 : 0));

  //return Math.max(height, maxHeight ? maxHeight : 720);
}

function CheckCircle({ }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
    </svg>
  );
}

function XCircle({ }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
    </svg>
  );
}
function focusOnFirstElement(modalSelector) {
  const focusableElements =
    'button, [href], input, select, textarea, [tabIndex]:not([tabIndex="-1"])';
  const modal = document.querySelector(modalSelector); // select the modal by it's id
  const firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal 
  firstFocusableElement.focus();
}
export function FirstTryIncorrect({ quiz, handleTryAgain }) {

  const holderRef = useRef(null);
  const handleResize = (e) => {
    const holderElement = holderRef.current;
    var quizHeadlineHeight = document.querySelector('.WeekQuiz').offsetHeight;
    holderElement.parentNode.style.height = getElementRealHeight(holderElement.firstElementChild, quizHeadlineHeight) + "px";
  }

  useEffect(() => {
    handleResize();
    //window.addEventListener("resize", handleResize);
    return () => {
      //window.removeEventListener("resize", handleResize);
      const quizElement = document.querySelector("#quiz-" + quiz.id);
      const quis = quizElement?.querySelectorAll(".QuestionUI");
      quis?.forEach(Q => {
        Q.style.removeProperty("height");
      });
    }
  }, []);

  useEffect(() => {
    focusOnFirstElement('.FirstTryIncorrect');
  }, []);

  return (

    <div className="Answer FirstTryIncorrect" ref={holderRef} data-layer-region="First Incorrect Answer" aria-modal="true" aria-live="polite" aria-describedby="header">
      <span className="mck-close-icon close-overlay" onClick={handleTryAgain}></span>
      <div className="wrapper">
        <h3 aria-label="Nice try, but not quite right." id="header" tabIndex="0">
          <span>Nice try, but not quite right.</span>
        </h3>
        <div className="cup">
          <img src="/spContent/bespoke/qotw/images/cupincorrect-sorry.gif" alt="Incorrect Icon" />
        </div>
        <button className="btn" onClick={handleTryAgain} data-layer-event-prefix="Navigation Link" data-layer-action="click" data-layer-category="Click here to try again!" data-layer-text="Click here to try again!" role="button">
          Click here to try again!
        </button>
      </div>
    </div>
  );
}

export function IncorrectAnswer({ quiz, article, answerDetail, handleAnotherQuestion, close, showNextQuestion }) {
  const { title, image, link, id } = article;

  const holderRef = useRef(null);

  const handleResize = (e) => {
    const holderElement = holderRef.current;
    //holderElement.parentNode.style.height = getElementRealHeight(holderElement.firstElementChild) + "px";
    holderElement.parentNode.style.height = getElementRealHeight(holderElement.firstElementChild, 0, showNextQuestion) + "px";
  }

  useEffect(() => {
    handleResize();
    //window.addEventListener("resize", handleResize);
    return () => {
      //window.removeEventListener("resize", handleResize);
      const quizElement = document.querySelector("#quiz-" + quiz.id);
      const quis = quizElement?.querySelectorAll(".QuestionUI");
      quis?.forEach(Q => {
        Q.style.removeProperty("height");
      });
    }
  }, []);
  useEffect(() => {
    focusOnFirstElement('.IncorrectAnswer');
  }, []);

  return (
    <div className="Answer IncorrectAnswer" ref={holderRef} data-layer-region="Second Incorrect Answer" aria-modal="true" aria-live="polite">
      <span className="mck-close-icon close-overlay" onClick={(e) => close()}></span>

      <div className="wrapper">
        <div className="text-center">
          <div className="cup top-right">
            <img src="/spContent/bespoke/qotw/images/cupincorrect-sorry.gif" alt="Incorrect icon" />
          </div>
          <div>
            <h3 tabIndex="0" aria-label="Sorry, that’s not it.">
              Sorry, that’s not it.
            </h3>
            <p className="title" tabIndex="0" dangerouslySetInnerHTML={{ __html: title }} />

          </div>
        </div>
        <div className="dive-in">
          <div className="col2">
            <div className="img-wrapper">
              <img src="https://www.mckinsey.com/~/media/mckinsey/Featured%20Insights/Data%20points/Data-hero-bottom-align-new" alt="Sorry, that’s not it icon." />
            </div>
            <div className="content-wrapper">
              <div className="more">Like quizzes?</div>
              <p>Check out Data Points, our weekly quiz feature, to find out how well you know your numbers.</p>


              <div className="cta-container">
                <a href="https://www.mckinsey.com/featured-insights/data-points" className="-arrow" target="_blank" data-layer-event-prefix="UI Item" data-layer-action="click" data-layer-category="Answer" data-layer-subcategory="Sorry, that's not it" data-layer-text={answerDetail.replace(/(<([^>]+)>)/ig, '')} rel="noreferrer">
                  Test yourself
                </a>
              </div>
            </div>
          </div>
        </div>
        {showNextQuestion &&
          <div className="another-question">
            <button className="btn" onClick={(e) => handleAnotherQuestion()}>
              Try next question
            </button>
          </div>
        }
        <WrongSocialsContainer quiz={quiz} />

      </div>
    </div>
  );
}

export function CorrectAnswer({ quiz, article, answerDetail, handleAnotherQuestion, close, showNextQuestion }) {
  const { title, image, link } = article;

  const holderRef = useRef(null);

  const handleResize = (e) => {
    const holderElement = holderRef.current;
    holderElement.parentNode.style.height = getElementRealHeight(holderElement.firstElementChild, 0, showNextQuestion) + "px";
  }

  useEffect(() => {
    handleResize();
    //window.addEventListener("resize", handleResize);
    return () => {
      //window.removeEventListener("resize", handleResize);
      const quizElement = document.querySelector("#quiz-" + quiz.id);
      const quis = quizElement?.querySelectorAll(".QuestionUI");
      quis?.forEach(Q => {
        Q.style.removeProperty("height");
      });
    }
  }, []);
  useEffect(() => {
    focusOnFirstElement('.CorrectAnswer');
  }, []);

  return (
    <div className="Answer CorrectAnswer" ref={holderRef} data-layer-region="Correct Answer" aria-modal="true" aria-live="polite">
      <span className="mck-close-icon close-overlay" onClick={(e) => close()}></span>

      <div className="wrapper">
        <div className="cup">
          <img src="/spContent/bespoke/qotw/images/cupcorrect-new.gif" alt="Correct icon" />
        </div>
        <div className="text-center">
          <h3 aria-label="Great job!" tabIndex="0">
            Great job!
          </h3>
          <p className="title" tabIndex="0" dangerouslySetInnerHTML={{ __html: title }} />
        </div>
        <div className="dive-in">

          <div className="col2">
            <div className="img-wrapper">
              <img src="https://www.mckinsey.com/~/media/mckinsey/Featured%20Insights/Data%20points/Data-hero-bottom-align-new" alt="Correct Icon" />
            </div>
            <div className="content-wrapper">
              <div className="more">Like quizzes?</div>
              <p tabIndex="0">Check out Data Points, our weekly quiz feature, to find out how well you know your numbers.</p>
              <div className="cta-container">
                <a href="https://www.mckinsey.com/featured-insights/data-points" className="-arrow" target="_blank" data-layer-event-prefix="UI Item" data-layer-action="click" data-layer-category="Answer" data-layer-subcategory="Sorry, that's not it" data-layer-text={answerDetail.replace(/(<([^>]+)>)/ig, '')} rel="noreferrer">
                  Test yourself
                </a>
              </div>
            </div>
          </div>
        </div>
        {showNextQuestion &&
          <div className="another-question">
            <button className="btn" onClick={(e) => handleAnotherQuestion()} data-layer-event-prefix="Navigation Link" data-layer-action="click" data-layer-category="Try next question" data-layer-text="Try another question" role="button">
              Try next question
            </button>
          </div>
        }
        <SocialsContainer quiz={quiz} />
      </div>
    </div>
  );
}
